import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

let ffmpegSingleton: FFmpeg | null = null;
let ffmpegLoaded = false;

async function getFfmpeg(): Promise<FFmpeg> {
  if (!ffmpegSingleton) {
    ffmpegSingleton = new FFmpeg();
  }
  if (!ffmpegLoaded) {
    try {
      // Вариант "по умолчанию" — грузим core/wasm с CDN.
      // При желании можно заменить на self-hosted URL через env.
      const coreBase = (import.meta as any).env?.VITE_FFMPEG_CORE_BASE_URL as string | undefined;
      const base = coreBase?.trim() || 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/esm';

      await ffmpegSingleton.load({
        coreURL: await toBlobURL(`${base}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${base}/ffmpeg-core.wasm`, 'application/wasm'),
      });
      ffmpegLoaded = true;
    } catch (error) {
      ffmpegLoaded = false;
      throw new Error(`Не удалось загрузить ffmpeg.wasm: ${error}`);
    }
  }
  return ffmpegSingleton;
}

/**
 * Конвертирует webm/opus (MediaRecorder) в WAV PCM16 mono 16kHz.
 * Такой WAV точно поддерживается роутером (format=wav).
 */
export async function transcodeToWavPcm16(input: Blob): Promise<Blob> {
  try {
    const ffmpeg = await getFfmpeg();

    const inName = 'in.webm';
    const outName = 'out.wav';

    // очищаем возможные хвосты от прошлых запусков
    try { await ffmpeg.deleteFile(inName); } catch { /* ignore */ }
    try { await ffmpeg.deleteFile(outName); } catch { /* ignore */ }

    await ffmpeg.writeFile(inName, await fetchFile(input));

    // PCM16, mono, 16kHz
    await ffmpeg.exec([
      '-i', inName,
      '-ac', '1',
      '-ar', '16000',
      '-c:a', 'pcm_s16le',
      outName
    ]);

    const outData = await ffmpeg.readFile(outName);
    const bytes = outData instanceof Uint8Array ? outData : new Uint8Array(outData as any);

    return new Blob([bytes], { type: 'audio/wav' });
  } catch (error) {
    throw error;
  }
}


